<template>
  <div class="wrapper">
    <div v-for="(item,i) in shopImg" :key="i" class="adv-img">
      <img :src="item.image" alt>
    </div>
  </div>
</template>

<script>
export default {
  name: "OneShop",
  components: {},
  props: {
    shopImg: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  watch: {},
  data() {
    return {};
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.wrapper {
  margin: 30px auto 22px;
  .adv-img {
    width: 100%;
    height: 120px;
    margin-bottom: 30px;
    img {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
    }
  }
}
</style>